<template>
  <form v-if="!loading" @submit.prevent="onSubmit()">
    <div class="row mb-2">
      <div class="col-12">
        <b-checkbox v-model="unit.active">Ativo</b-checkbox>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6 col-lg-4 col-xl-3">
        <app-autocomplete
          label="Rede"
          field="name"
          :searchFunction="searchNetworkFn"
          :resourceIdFunction="resourceNetworkFn"
          v-model="unit.network_id"
          :errors="errors.network_id"
          required
        ></app-autocomplete>
      </div>
      <div class="col-sm-6 col-lg-4 col-xl-3">
        <app-input
          label="CNPJ Loja"
          v-model="unit.cnpj"
          v-mask="'##.###.###/####-##'"
          :errors="errors.cnpj"
          required
        ></app-input>
      </div>
      <div class="col-sm-6 col-lg-4 col-xl-3">
        <app-input
          label="Nome"
          v-model="unit.name"
          :errors="errors.name"
          required
        ></app-input>
      </div>
      <div class="col-sm-6 col-lg-4 col-xl-3">
        <app-input
          label="CPF Responsável"
          v-model="unit.responsible_cpf"
          v-mask="'###.###.###-##'"
          :errors="errors.responsible_cpf"
        ></app-input>
      </div>
      <div class="col-sm-6 col-lg-4 col-xl-3">
        <app-input
          label="Nome Responsável"
          v-model="unit.responsible_name"
          :errors="errors.responsible_name"
        ></app-input>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6 col-lg-4 col-xl-3">
        <app-input
          label="E-mail"
          v-model="unit.email"
          :errors="errors.email"
        ></app-input>
      </div>
      <div class="col-sm-6 col-lg-4 col-xl-3">
        <app-input
          label="Telefone Celular"
          v-model="unit.cellphone"
          v-mask="'(##) #####-####'"
          :errors="errors.cellphone"
        ></app-input>
      </div>
      <div class="col-sm-6 col-lg-4 col-xl-3">
        <app-input
          label="Telefone Adicional"
          v-model="unit.phone"
          v-mask="'(##) #####-####'"
          :errors="errors.phone"
        ></app-input>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6 col-xl-4">
        <app-input
          label="Rua"
          v-model="unit.address.street"
          :errors="errors['address.street']"
        ></app-input>
      </div>
      <div class="col-sm-3 col-lg-2">
        <app-input
          label="Número"
          v-model="unit.address.number"
          :errors="errors['address.number']"
        ></app-input>
      </div>
      <div class="col-sm-3 col-lg-2">
        <app-input
          label="Complemento"
          v-model="unit.address.complement"
          :errors="errors['address.complement']"
        ></app-input>
      </div>
      <div class="col-sm-4 col-lg-3 col-xl-2">
        <app-input
          label="Bairro"
          v-model="unit.address.neighborhood"
          :errors="errors['address.neighborhood']"
        ></app-input>
      </div>
      <div class="col-sm-4 col-lg-3 col-xl-2">
        <app-autocomplete
          label="Cidade"
          field="name_with_state"
          :searchFunction="searchCityFn"
          :resourceIdFunction="resourceCityFn"
          v-model="unit.address.city_id"
          :errors="errors['address.city_id']"
        ></app-autocomplete>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <button :disabled="$v.$invalid || saving" type="submit" v-app-button>
          Salvar
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import CityService from '@/services/city.service';
import NetworkService from '@/services/network.service';
import UnitService from '@/services/unit.service';
import ToastMixin from '@/mixins/ToastifyMixin';

import { required, email } from 'vuelidate/src/validators';

export default {
  name: 'units-form',
  props: ['id', 'errors', 'saving'],
  mixins: [ToastMixin],
  data: () => {
    return {
      loading: true,
      unit: {
        active: true,
        cnpj: null,
        name: null,
        email: null,
        cellphone: null,
        phone: null,
        network_id: null,
        address: {
          street: null,
          number: null,
          complement: null,
          neighborhood: null,
          city_id: null,
        },
      },
    };
  },
  validations: {
    unit: {
      network_id: { required },
      cnpj: { required },
      name: { required },
      email: {
        email,
      },
    },
  },
  methods: {
    loadUnit(id) {
      UnitService.getId(id)
        .then(({ data: unit }) => {
          this.unit = {
            ...unit,
            address: unit.address || {},
          };
        })
        .catch(() => this.toastify('Erro ao carregar Unidade.', 'error'))
        .finally(() => (this.loading = false));
    },
    onSubmit() {
      this.$emit('submit', this.unit);
    },
    searchNetworkFn: NetworkService.search,
    resourceNetworkFn: NetworkService.getId,
    searchCityFn: CityService.search,
    resourceCityFn: CityService.getId,
  },
  beforeMount() {
    if (this.id) this.loadUnit(this.id);
    else this.loading = false;
  },
};
</script>
